import { create } from "zustand";

interface CreateDialog {
  isDialogOpen: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
}

interface DeleteDialog {
  isDeleteDialogOpen: boolean;
  setIsDeleteDialogOpen: (isDeleteDialogOpen: boolean) => void;
}

export const useDeleteDialog = create<DeleteDialog>()((set) => ({
  isDeleteDialogOpen: false,
  setIsDeleteDialogOpen: (isDeleteDialogOpen) => set({ isDeleteDialogOpen }),
}));

export const useDialog = create<CreateDialog>()((set) => ({
  isDialogOpen: false,
  setIsDialogOpen: (isDialogOpen) => set({ isDialogOpen }),
}));
